import type { AtomEffect } from 'recoil';

// SessionStorage effect for persistence across page reloads
export const sessionStorageEffect =
  <T>(key: string): AtomEffect<T> =>
  ({ setSelf, onSet }) => {
    const savedValue = sessionStorage.getItem(key);

    if (savedValue !== null) {
      try {
        setSelf(JSON.parse(savedValue) as T);
      } catch (error) {
        sessionStorage.setItem(key, '');
        console.warn(`Failed to parse sessionStorage value for key "${key}":`, error);
      }
    }

    onSet((newValue: T, _, isReset) => {
      isReset ? sessionStorage.removeItem(key) : sessionStorage.setItem(key, JSON.stringify(newValue));
    });
  };

// LocalStorage effect for persistence across page reloads and between sessions
export const localStorageEffect =
  <T>(key: string): AtomEffect<T> =>
  ({ setSelf, onSet }) => {
    const savedValue = localStorage.getItem(key);

    if (savedValue !== null) {
      try {
        setSelf(JSON.parse(savedValue) as T);
      } catch (error) {
        localStorage.setItem(key, '');
        console.warn(`Failed to parse localStorage value for key "${key}":`, error);
      }
    }

    onSet((newValue: T, _, isReset) => {
      isReset ? localStorage.removeItem(key) : localStorage.setItem(key, JSON.stringify(newValue));
    });
  };
